import { Rotate90DegreesCcw } from "@mui/icons-material";
import { Modal, ModalDialog, Stack, DialogTitle, DialogContent, Box } from "@mui/joy";
import { useMediaQuery } from "react-responsive";
import { useOrientation } from "react-use";

export const OrientationModal = () => {
  const isPhone = useMediaQuery({ query: "(max-width: 600px)" });
  const { type } = useOrientation();
  if (!isPhone && type.includes("portrait") && navigator.userAgent.match(/ipad|tablet/)) {
    return (
      <Modal open={true}>
        <ModalDialog>
          <DialogTitle>Rotate your device</DialogTitle>
          <DialogContent>
            <Stack>
              <Box sx={{ textAlign: "center" }}>
                <Rotate90DegreesCcw sx={{ fontSize: 48 }} />
              </Box>
              <Box sx={{ textAlign: "center" }}>
                Please rotate your device to landscape mode for the best experience.
              </Box>
            </Stack>
          </DialogContent>
        </ModalDialog>
      </Modal>
    );
  }
};
